import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function for merging Tailwind CSS classes with intelligent conflict resolution.
 * Combines clsx for conditional class building with twMerge for Tailwind CSS class merging.
 *
 * @param inputs - Array of class values (strings, objects, arrays, etc.)
 * @returns Merged class string with conflicts resolved
 *
 * @example
 * // Basic usage
 * cn('px-2 py-1', 'px-4')  // => 'py-1 px-4' (px-4 overrides px-2)
 *
 * // Conditional classes
 * cn('text-white', isActive && 'bg-blue-500')  // => 'text-white bg-blue-500' (if isActive is true)
 *
 * // Combining with component props
 * cn('px-4 py-2', variant === 'large' && 'text-lg', className)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
